import { ReactNode } from 'react';

import { MetadataText, formatDuration } from '@spotify/confidence-core-react';

type EndedRuntimeTextProps = {
  label: ReactNode;
  actualRuntime?: number | null;
};

export const EndedRuntimeText = ({
  label,
  actualRuntime,
}: EndedRuntimeTextProps) => (
  <MetadataText
    items={[label, actualRuntime && formatDuration(actualRuntime)]}
  />
);
